exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#home[data-v-9e73dc96]{width:100%;height:100%;box-sizing:border-box;margin:0;padding:0;min-width:1360px}", ""]);

// exports
